import { CoralException } from '@ch-types/CoralException';

export default class ResourceVersionConflictException extends CoralException {}
